import React from 'react'
import { preloadImage } from '~/common/domUtils'

preloadImage('/static/images/logo-workday-vndly.png')
preloadImage('/static/images/logo-workday-vndly@2x.png')
preloadImage('/static/images/logo-workday-vndly.webp')

export function WorkdayVndlyLogo(props: React.ImgHTMLAttributes<HTMLImageElement>) {
  return (
    <picture>
      <source srcSet="/static/images/logo-workday-vndly.webp" type="image/webp" />
      <source
        srcSet="/static/images/logo-workday-vndly.png 1x, /static/images/logo-workday-vndly@2x.png 2x"
        type="image/png"
      />
      <img
        src="/static/images/logo-workday-vndly.png"
        alt="Workday VNDLY Logo"
        id="workday-vndly-logo"
        // render it at 50% of its original size
        width="236"
        height="60"
        {...props}
      />
    </picture>
  )
}
